import React from 'react';
import { Combobox } from 'evergreen-ui';

/**
 * Компонент с выбором юзеров для поиска
 * */
export const SearchSelectOnUsers = React.memo(({
  users,
  selectedUser,
  onChangeUser,
  initialSelectedItem,
  }) => (
    <Combobox
      items={users}
      itemToString={(user) => (user?.email ? `[${user?.email}] ${user?.username}` : `${user?.username}`)}
      value={selectedUser}
      initialSelectedItem={initialSelectedItem}
      onChange={onChangeUser}
      placeholder="Выберите пользователя"
    />
  ));

SearchSelectOnUsers.displayName = 'SearchSelectOnUsers';
